import { FetchFromLocalStorage } from '../../helpers';
import { Action } from '@ngrx/store';
import { Initialize, OverviewStackActionTypes, Pop, Push } from './overview-stack.actions';

import { OverviewStackState } from './overview-stack.entity';

export const initialState: OverviewStackState = FetchFromLocalStorage('overviewStack') || {};

export function overviewStackReducer(state = initialState, action: Action): OverviewStackState {
    switch (action.type) {
        case OverviewStackActionTypes.Initialize: {
            const initialize: Initialize = action as Initialize;
            return { ...state, stack: [initialize.overview] };
        }

        case OverviewStackActionTypes.Clear: {
            return { ...state, stack: [] };
        }

        case OverviewStackActionTypes.Push: {
            const push: Push = action as Push;
            const newStack = [...(state.stack || [])];
            newStack.push(push.overview);
            return { ...state, stack: newStack };
        }

        case OverviewStackActionTypes.Pop: {
            const pop: Pop = action as Pop;
            let newStack: string[] = [];
            if (state.stack && state.stack.length > 0) {
                if (pop.overview) {
                    const index: number = state.stack.lastIndexOf(pop.overview);
                    newStack = index >= 0 ? state.stack.slice(0, index) : state.stack;
                } else {
                    newStack = state.stack.slice(0, state.stack.length - 1);
                }
            }
            return { ...state, stack: newStack };
        }

        default: {
            return state;
        }
    }
}
